import clsx from 'clsx';
import React from 'react';

interface TagProps {
  className?: string;
  name: string;
}

const Tag = ({ name, className }: TagProps) => {
  return (
    <span
      className={clsx(
        'sm:text-xs ml-auto hidden whitespace-nowrap rounded-28 bg-primary-red px-12 py-2 font-sans text-body-sm text-white xs:block',
        className
      )}
    >
      {name}
    </span>
  );
};

export default Tag;
